import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware } from 'redux';
import thunkMiddleware from 'redux-thunk';
import createSagaMiddleware from 'redux-saga';
import * as Logger from 'js-logger';
import './index.css';
import App from './App.jsx';

/***************************************************************************************************
 * BROWSER POLYFILLS
 */

/** IE9, IE10 and IE11 requires all of the following polyfills. **/
import 'core-js/es6/symbol';
import 'core-js/es6/object';
import 'core-js/es6/function';
import 'core-js/es6/parse-int';
import 'core-js/es6/parse-float';
import 'core-js/es6/number';
import 'core-js/es6/math';
import 'core-js/es6/string';
import 'core-js/es6/date';
import 'core-js/es6/array';
import 'core-js/es6/regexp';
import 'core-js/es6/map';
import 'core-js/es6/weak-map';
import 'core-js/es6/set';




import registerServiceWorker from './registerServiceWorker';
import reducers from './store/reducers';
import rootSaga from './store/sagas'
import {isIFrame} from "./tools/utils";
import * as QueryString from "query-string";


let defaultState = isIFrame() ? QueryString.parse(window.location.search) : {}
//let CurrentStyle = isIFrame() ? React.lazy(() => {import ('./App.scss')}) : React.lazy(() => {import ('./App-plugin.scss')});
isIFrame() ?  require('./App.scss') : require('./App-plugin.scss');


window.renderPlayerToElement = (selector = '#root', initialState = defaultState, createWrapper = false) => {
  if (window.require && window.define) {
    window.define = null;
    window.require = null;
  }

  let renderedElement = document.querySelector(selector);
  const sagaMiddleware = createSagaMiddleware();
  const createStoreWithMiddleware = applyMiddleware(
      thunkMiddleware,
      sagaMiddleware,
  )(createStore);
  const store = createStoreWithMiddleware(
      reducers,
     process.env.NODE_ENV === 'development' ?
       window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__() : {}
  );

  sagaMiddleware.run(rootSaga);

  Logger.useDefaults({
    defaultLevel: Logger.DEBUG,
    formatter: (messages, context) => {
      messages.unshift(`[${context.name}]-[${new Date().toLocaleTimeString()}]`);
    }
  });

  initialState.parentSelector = selector;

  if (createWrapper) {
    let wrapper = document.createElement('div');
    wrapper.id = 'we-are-cinebooks-container' + selector;
    wrapper.classList.add('lazyload');
    renderedElement.appendChild(wrapper);
    renderedElement = wrapper;
  }
  ReactDOM.render(
      <Provider store={store}>
        <App
            renderedElement={renderedElement}
            initData={initialState}
        />
      </Provider>
      , renderedElement);
  registerServiceWorker();
}

isIFrame() && window.renderPlayerToElement();




// WEBPACK FOOTER //
// ./src/index.js